export var replaceInTemplate = function replaceInTemplate(text, placeholder, value) {
  return text.split("{{".concat(placeholder, "}}")).join(value);
};